import { useState } from 'react'
import Image from 'next/image'
import Link from 'next/link'
import cx from 'classnames'

import styles from 'styles/help_details.module.scss'

export default function FeaturedFAQSection() {
  const [question1Active, setQuestion1Active] = useState(true)
  const [question2Active, setQuestion2Active] = useState(false)
  const [question3Active, setQuestion3Active] = useState(false)

  return (
    <div className={styles.featured_faq_section}>
      <div className={styles.featured_faq_section_bg_vector}>
        <Image src="/images/help_details/featured_faq_bg_vector.png" alt="Bg" layout="fill" />
      </div>
      <div className={styles.featured_faq_section_container}>
        <div className={cx('heading_1', styles.featured_faq_section_title)}>Featured FAQs</div>
        <div className={styles.featured_faq_area}>
          <div
            className={cx(styles.featured_faq_question, question1Active && styles.active)}
            onClick={() => setQuestion1Active(!question1Active)}
          >
            <div className={cx('heading_3', styles.featured_faq_question_content)}>How to create multiple Outings</div>
            {question1Active ? (
              <Image alt="Arrow Active" src="/images/help_details/arrow_active.png" width={14.73} height={8.36} />
            ) : (
              <Image alt="Arrow" src="/images/help_details/arrow.png" width={14.73} height={8.36} />
            )}
          </div>
          <div className={cx('description_small', styles.featured_faq_answer, !question1Active && styles.hide)}>
            Whether you’re in the office or working online, we have team building games for you! From truly competitive
            to silly fun, group up with anyone in your team to conquer these engaging games.
          </div>
          <div className={cx(styles.featured_faq_question, question2Active && styles.active)}>
            <div
              className={cx('heading_3', styles.featured_faq_question_content)}
              onClick={() => setQuestion2Active(!question2Active)}
            >
              Receiving your team Outing details via email
            </div>
            {question2Active ? (
              <Image alt="Arrow Active" src="/images/help_details/arrow_active.png" width={14.73} height={8.36} />
            ) : (
              <Image alt="Arrow" src="/images/help_details/arrow.png" width={14.73} height={8.36} />
            )}
          </div>
          <div className={cx('description_small', styles.featured_faq_answer, !question2Active && styles.hide)}>
            If you enter your email when creating the Outing, you’ll get a special “edit” link that you can use anytime
            to edit the outing.
          </div>
          <div
            className={cx(styles.featured_faq_question, question3Active && styles.active)}
            onClick={() => setQuestion3Active(!question3Active)}
          >
            <div className={cx('heading_3', styles.featured_faq_question_content)}>Team Games Pricing</div>
            {question3Active ? (
              <Image alt="Arrow Active" src="/images/help_details/arrow_active.png" width={14.73} height={8.36} />
            ) : (
              <Image alt="Arrow" src="/images/help_details/arrow.png" width={14.73} height={8.36} />
            )}
          </div>
          <div className={cx('description_small', styles.featured_faq_answer, !question3Active && styles.hide)}>
            Enjoy Team Games for free while we're in beta!
          </div>
        </div>
        <div className={styles.featured_faq_buttons}>
          <Link href="/contact-us">
            <a>
              <span className="large_btn button_big">Contact Us</span>
            </a>
          </Link>
          <Link href="/blog/faq">
            <a>
              <span className="large_btn button_big">Learn More</span>
            </a>
          </Link>
        </div>
      </div>
    </div>
  )
}
